<script>
import TheNavBar from './header/TheNavBar'
import CookieLaw from './CookieLaw'

export default {
  components: {
    TheNavBar,
    CookieLaw,
  },
  data: function () {
    return {
      isOpen: false
    };
  },

  watch: {
    isOpen (newValue) {
      this.$root.disableScroll = newValue
    }
  },

  methods: {
    toggle: function () {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>



// WEBPACK FOOTER //
// assets/js/components/TheHeader.vue